import React from 'react';
import './index.less';

type SelecterItemProps = {
    active?: boolean;
    onClick?: () => void;
} & Props;

const SelecterItem: React.FC<SelecterItemProps> = (props: SelecterItemProps) => {
    const { active } = props;

    return (
        <div className={`selecter-item ${active ? 'active' : ''}`} onClick={props.onClick}>
            <span className="selecter-item-text">{props.children}</span>
            {!!active && <span className="at-icon at-icon-check"></span>}
        </div>
    );
};

SelecterItem.defaultProps = {
    active: false,
    onClick: () => {},
};

export default SelecterItem;
